import { resolveDomain } from '../../../utils'
import { API_AUTH_BASE_PATH, API_AUTH_LOGOUT } from '../constants'

export const signOutHandler = () => {
  window.location.href = `${resolveDomain()}${API_AUTH_BASE_PATH}/${API_AUTH_LOGOUT}`
}
